import { MutationTree } from 'vuex'

import { RecommendState } from '@/types/store'
import { IRecommend } from '@/types/recommend'

export const mutations: MutationTree<RecommendState> = {
  recommendsLoadStart(state) {
    state.isRecommendsLoading = true
  },
  recommendsLoaded(state, recommends: IRecommend[]) {
    state.recommends = recommends
    state.isRecommendsLoading = false
  },
}
